import SiderMenu from 'layout/SiderMenu'

import logo from '../assets/logo.svg'
import { useIntl } from "react-intl"

export default function LeftSiderContent() {

  const intl = useIntl()

  return (
    <div className="tw-flex tw-h-full tw-flex-col tw-justify-between tw-overflow-y-auto tw-px-1 tw-pt-2">
      <div className="tw-flex tw-justify-center">
        <div><img src={logo} width={40} height={40}></img></div>
        <div className="tw-text-[18px] tw-font-bold tw-mt-2 ">{intl.formatMessage({ id: "system.main.title" })}</div>
      </div>
      <div className="tw-flex-1 tw-pt-5">
        <SiderMenu />
      </div>
    </div>
  )
}
